
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_1csi5_97",
  "tools": "awsui_tools_wih1l_1csi5_108",
  "tools-filtering": "awsui_tools-filtering_wih1l_1csi5_114",
  "tools-align-right": "awsui_tools-align-right_wih1l_1csi5_128",
  "tools-pagination": "awsui_tools-pagination_wih1l_1csi5_132",
  "tools-preferences": "awsui_tools-preferences_wih1l_1csi5_132",
  "tools-small": "awsui_tools-small_wih1l_1csi5_138",
  "table": "awsui_table_wih1l_1csi5_144",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_1csi5_150",
  "wrapper": "awsui_wrapper_wih1l_1csi5_154",
  "variant-stacked": "awsui_variant-stacked_wih1l_1csi5_161",
  "variant-container": "awsui_variant-container_wih1l_1csi5_161",
  "has-footer": "awsui_has-footer_wih1l_1csi5_165",
  "has-header": "awsui_has-header_wih1l_1csi5_168",
  "cell-merged": "awsui_cell-merged_wih1l_1csi5_182",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_1csi5_193",
  "empty": "awsui_empty_wih1l_1csi5_208",
  "loading": "awsui_loading_wih1l_1csi5_212",
  "selection-control": "awsui_selection-control_wih1l_1csi5_221",
  "selection-control-header": "awsui_selection-control-header_wih1l_1csi5_228",
  "dark-header": "awsui_dark-header_wih1l_1csi5_237",
  "header-secondary": "awsui_header-secondary_wih1l_1csi5_242",
  "table-has-header": "awsui_table-has-header_wih1l_1csi5_258",
  "header-controls": "awsui_header-controls_wih1l_1csi5_262",
  "variant-full-page": "awsui_variant-full-page_wih1l_1csi5_266",
  "variant-embedded": "awsui_variant-embedded_wih1l_1csi5_274",
  "variant-borderless": "awsui_variant-borderless_wih1l_1csi5_274",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_1csi5_280",
  "footer": "awsui_footer_wih1l_1csi5_280",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_1csi5_288",
  "footer-pagination": "awsui_footer-pagination_wih1l_1csi5_296",
  "thead-active": "awsui_thead-active_wih1l_1csi5_300",
  "row": "awsui_row_wih1l_1csi5_301",
  "row-selected": "awsui_row-selected_wih1l_1csi5_302"
};
  